<template>
<div>
    <div v-if="!loading">
        <v-sheet outlined >
            <v-simple-table dense>
                <tbody>
                    <div v-if="!data" class="mt-5">
                        <div class="text-center" v-for=" (error, i) in errors" :key="i">
                            {{ error }}
                        </div>
                        <div class="text-center ma-2">
                            <v-btn outlined @click="fetchData()">
                                <span class="me-2">{{ $t("REFRESH") }}</span>
                                <v-icon left>mdi-refresh</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <FailureTableRow
                        v-else-if="data"  
                        v-for="(d, i) in data"
                        :key="i" 
                        :data="d"
                        @delete="handelDelete" 
                        :deleteLoading="deleteLoading" 
                        @editRecord="handelEditRecord"
                        />
                </tbody>
            </v-simple-table>
        </v-sheet>
    </div>
    <div v-else>
        <v-progress-linear
            class="my-4"
            indeterminate
            color="yellow darken-2"
        ></v-progress-linear>
    </div>
</div>
</template>

<script>
import FailureTableRow from './FailureTableRow'
import {getMalfactions} from '../services/malfactions'
export default {
    name: "FailureTable",
    components: {FailureTableRow},
    props: {
        deleteLoading: Number 
    },
    data() {
        return {
            data: [],
            loading: false,
            editMode: false,
            errors: []
        }
    },
    methods: {
        async fetchData() {
            this.clearErrors()
            this.loading = true
            try { 
                let response = await getMalfactions()
                this.data = response.data
                this.loading = false
                this.$emit('loading', this.loading)
            } catch(error){
                let message = error.response ? error.response.data.message : error
                this.setErrors(message)
            }
        },
        handelEdit() {
            this.editMode = !this.editMode
        },
        addNewRecord(record) {
            this.data.push(record)
        },
        handelDelete(id) {
            this.$emit('delete', id)
        },
        deleteFailure(id) {
            this.data = this.data.filter((item) => {
                return item.id !== id
            })
        },
        handelEditRecord(record) {
            let findRecord = this.data.find( element => element.id === record.id )
            findRecord.name = record.name
        },
        setErrors(message) {
            this.errors.push(message)
        },
        clearErrors(){
            this.errors.splice(0, this.errors.length -1 )
        }

    },
    mounted() {
        this.fetchData()
    },
    watch: {
        loading(val) {
            this.$emit("loading", val)
        }
    }

}
</script>

<style>

</style>